import {find} from '../helpers';

const element = find('[data-highlighter]');

if (element) {
    import('./index');
}
